import React from 'react';
import { AlertCircle } from 'lucide-react';
export function UrgencySection() {
  return <section className="py-20 bg-white border-y border-sage/10" data-id="element-295">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-296">
        <div className="inline-flex items-center gap-2 text-terracotta font-bold uppercase tracking-wide text-sm mb-6" data-id="element-297">
          <AlertCircle className="h-4 w-4" data-id="element-298" />
          <span data-id="element-299">Importante</span>
        </div>

        <h2 className="text-2xl md:text-3xl font-bold text-forest mb-8 font-serif" data-id="element-300">
          Pero necesito ser honesta contigo:
        </h2>

        <div className="space-y-6 text-lg text-forest/80 leading-relaxed" data-id="element-301">
          <p data-id="element-302">
            Este precio de{' '}
            <span className="font-bold text-terracotta" data-id="element-303">$6.39</span> con todos
            los bonos incluidos es una oferta de lanzamiento.
          </p>

          <p data-id="element-304">No sé exactamente cuánto tiempo va a estar disponible.</p>

          <div className="py-6" data-id="element-305">
            <p className="font-bold text-forest text-xl" data-id="element-306">
              Lo que sí sé es esto:
            </p>
          </div>

          <p data-id="element-307">
            La próxima vez que tu hijo amanezca con fiebre, tos, o dolor de
            barriga a las 2AM...
          </p>

          <p className="text-xl font-serif italic text-forest" data-id="element-308">
            Vas a desear haber tomado esta decisión hoy.
          </p>

          <p className="font-medium" data-id="element-309">
            No mañana. No cuando tengas más tiempo.{' '}
            <span className="underline decoration-terracotta decoration-2 underline-offset-4" data-id="element-310">
              Hoy — mientras todavía tienes acceso a este precio.
            </span>
          </p>
        </div>
      </div>
    </section>;
}